/**
 * /pages/Users.js – Работа со настройками пользователей — курьеры и обычные пользователи
 * /stores/users.js – бизнес логика
 * 
 * Для получения списка пользователей необходимо сделать запрос «Users»
 * Для получения списка курьеров необходимо сделать запрос «Couriers»
 * 
 * Для просмотра/редактирования/удаления пользователей необходимо право «ManageUsers»
 * Для просмотра/редактирования/удаления курьеров необходимо право «ManageCouriers»
 * 
 * Для того, чтобы видеть какие пользователя, являются получаетелями чаевых, назначать получателей чаевых
 * 		необходимо право «ManageRecipient»
 * 
 * Для изменения настроек пользователя/курьера необходимо сделать запрос «UserSave»
 * Чтобы удалить пользователя/курьера необходимо отправить запрос «UserDelete»
 * 
 * Для получения дополнительных данных необходимо отправить запросы
 * 		«Rights» для получения списка прав
 * 		«Dashboards» для получения списка рабочих столов
 * 		«NotificationTypes» для получения списка уведомлений
 * 
 * Для работы со сменами курьеров необходимо право «CanCourierShift» и открытая смена пользователя 
 * 		в том же филиале
 * Для открытия/закрытия смены курьера неоходимо отправить запрос «ToggleCourierShift»
 * 
 * На странице блоки настроек зависят от подключенных модулей
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import '../styles/users.css';

import { CourierState, UserState } from '../stores/users';
import { confirmState, authUserState, errorState, uistate } from '../stores/common';
import { CourierApi, FilialApi, MerchantApi, PasswordApi, RoleApi, SystemApi, UserApi } from '../stores/apiMethods';

import { TablePageContent } from '../shared/TableComponents';
import { DashboardBlock, NotificationBlock, RightsBlock } from '../shared/AccessComponents';
import { CreateButton, ItemNewHeader } from '../shared/PageComponents';
import { FormModal, InlineError, OpenShiftInformer } from '../shared/FeedbackComponents';
import { TextInput, CheckGroup, CheckFilter, DateInput, GroupCheckbox } from '../forms/FormItems';
import { ButtonSelectGroup, CheckBoxGroup } from '../shared/FormElements';
import {
	AccessDeniedIcon,
	AccessKeyIcon,
	CashRegisterIcon,
	ClockIcon,
	LocationAccessIcon
} from '../images/icons';

import { buttonTitles, dashboardsTitles, TipsStateTitles } from '../dictionary';

export class UsersPage extends Component {
	constructor(props) {
		super(props);

		this.store = new UserState();
	}

	/** API «Users» запрос на получение списка пользователей */
	getData () {
		this.store.IsSendRequest = false;
		UserApi.getList(this.store.getFilter(), (data) => { this.store.setUsers(data); });
	}

	render() {
		return (<UsersCommonPage Type={this.props.Type} store={this.store} getData={this.getData.bind(this)} />);
	}
}

export class CouriersPage extends Component {
	constructor(props) {
		super(props);

		this.store = new CourierState(this.props.Type);
	}

	/** API «Couriers» запрос на получение списка курьеров */
	getData () {
		this.store.IsSendRequest = false;
		CourierApi.getList(this.store.getFilter(), (data) => { this.store.setUsers(data); });
	}

	render() {
		return (<UsersCommonPage Type={this.props.Type} store={this.store} getData={this.getData.bind(this)} />);
	}
}

class UsersCommonPage extends Component {
	componentDidMount() {
		if (this.props.getData) this.props.getData();

		FilialApi.getList((data) => {
			this.props.store.FilialList = data.Success ? data.Filials : [];
		});
		MerchantApi.getList((data) => {
			this.props.store.MerchantList = data.Success ? data.Merchants : [];
		});
		RoleApi.getList(true, (data) => {
			this.props.store.RoleList = data.Success ? data.Roles : [];
		});
		
		if (this.props.Type === "Users") {
			SystemApi.getRights((data) => {
				this.props.store.RightsList = data.Success && !_.isNil(data.Rights) ? data.Rights : [];
			});
			SystemApi.getDashboards((data) => {
				this.props.store.DashboardList = data.Success && !_.isNil(data.Dashboards) ? data.Dashboards : [];
			});
			SystemApi.getNotificationTypes((data) => {
				this.props.store.NotificationList = data.Success && !_.isNil(data.Notifications) ? data.Notifications : [];
			});
		}
	}

	/** API запрос «User» на получение конкретного пользвователя по ID
	 * @param {number} id ID пользователя
	 */
	getItem(id) {
		UserApi.getById(id, (data) => {
			this.props.store.setUser(data.Success ? data : undefined);
		});
	}

	/** Получение конкретного пользователя
	 * @param {number} id ID пользователя
	 */
	setId(id) { 
		if (!_.isUndefined(id)){ 
			if (id !== -1) this.getItem(id);
			else {
				if (this.props.store.CourierInterface || this.props.store.HasAvailableUserSlot)
					this.props.store.setUser({ Id : -1 });
				else errorState.setError("MERCHANT_USERLIMIT")
			}
		} else {
			this.props.store.setUser(undefined);
			this.props.getData();
		}
	}

	/** API запрос «UserDelete» на удаление пользователя
	 * @param {number} id ID пользователя
	 */
	removeId = (id) => {
		if (_.isUndefined(id)) return false;

		if (!this.props.store.CourierInterface && !this.props.store.Filter.Active && !this.props.store.HasAvailableUserSlot) {
			errorState.setError("MERCHANT_USERLIMIT")
			return false;
		}

		var item = _.find(this.props.store.Users, { Id : id }),
			text = <span>Вы действительно хотите {this.props.store.Filter.Active ? "удалить" : "восстановить"}
				&nbsp;пользователя <b key="b1">«{item ? item.Name : ""}»</b>?</span>;

		confirmState.openConfirm(text, () => {
			UserApi.remove(id, () => { this.props.getData(); });
		});
	}

	/** 
	 * Переключатель фильтра пользователей 
	 * @param {boolean} value Значение фильтра
	 * @param {string} id Название поля фильтра
	 */
	setFilter (value, id) {
		this.props.store.Filter[id] = value;
		if (this.props.getData) this.props.getData();
	}

	render() {
		return (
			<div className="page" id="UsersPage">
				<section className="listpage">
					{_.isUndefined(this.props.store.User) &&
						<>
							<div className={"head " + (uistate.IsMobile ? "mobile" : "")}>
								<h2>{dashboardsTitles[this.props.Type] || this.props.Type}</h2>
								<div className="filter form">
									<ButtonSelectGroup
										Id="Active"
										List={[
											{ Id : true, Name : "Активные" },
											{ Id : false, Name : "Удалённые", Style : "red" }
										]}
										Value={this.props.store.Filter.Active}
										RowClass="nomargin"
										onChange={(value, id) => this.setFilter(value, id)}
									/>
									{!_.isUndefined(this.props.store.Filter.TipsRecipient) &&
										<CheckFilter
											Id="TipsRecipient"
											Title="Только получатели чаевых"
											Value={this.props.store.Filter.TipsRecipient}
											RowClass="nomargin"
											onChange={(value, id) => this.setFilter(value, id)}
										/>
									}
								</div>
								{this.props.store.CanManage && this.props.store.Filter.Active &&
									<CreateButton Title={buttonTitles[this.props.Type]} onClick={() => this.setId(-1)} />
								}
								{this.props.store.CourierInterface && this.props.store.Filter.Active &&
									this.props.store.CanOpenShift && !this.props.store.CanToggleShift &&
									<OpenShiftInformer
										Text="Откройте смену, чтобы управлять сменами курьеров в соответствующем филиале"
									/>
								}
							</div>
							{this.props.store.IsSendRequest &&
								<TablePageContent
									key={this.props.Type + this.props.store.Filter.Active}
									Type={this.props.Type}
									TableData={this.props.store.Users}
									TableColumns={this.props.store.CourierInterface && !_.isUndefined(this.props.store.columns.ToggleShift) ? {
										...this.props.store.columns,
										ToggleShift : {
											...this.props.store.columns.ToggleShift,
											Cell : row => <CourierShiftCell store={this.props.store} courier={row.original} />
										}
									} : this.props.store.columns}
									TableFilterable={true}
									Sorted={this.props.store.CourierInterface && this.props.store.Filter.Active
										? [{ id: "ToggleShift", desc: false }] : []}
									setId={this.setId.bind(this)}
									removeId={this.removeId.bind(this)}
									getTrProps={(state, rowInfo, column) => {
										return { className: rowInfo && !rowInfo.original.Active ? "notactive" : "" };
									}}
								/>
							}
						</>
					}
				</section>
				{!_.isUndefined(this.props.store.User) &&
					<UserItem
						Type={this.props.Type}
						store={this.props.store}
						setId={this.setId.bind(this)}
					/>
				}
				{!_.isUndefined(this.props.store.CourierShift) && this.props.store.CanOpenShift &&
					<CourierShift store={this.props.store} getData={this.props.getData} />
				}
			</div>
		)
	}
}
UsersCommonPage = observer(UsersCommonPage);

/** Управление сменой курьера в строке списка */
class CourierShiftCell extends Component {
	render() {
		if (this.props.courier.ShiftState === "open") {
			return <button className="button shift open green"
				onClick={() => this.props.store.toggleCourierShift(this.props.courier)}>Открыть смену</button>;
		}

		if (this.props.courier.ShiftState === "close") {
			return <button className="button shift close red"
				onClick={() => this.props.store.toggleCourierShift(this.props.courier)}>Закрыть смену</button>;
		}

		if (this.props.courier.ShiftState === "unavailable") {
			return <span className="courierShiftState unavailable">
				<AccessDeniedIcon />У курьера нет доступа к филиалу
			</span>;
		}

		if (this.props.courier.ShiftState === "another") {
			return <span className="courierShiftState another">
				<LocationAccessIcon />Открыта смена в «{this.props.courier.ShiftFilialName}»
			</span>;
		}

		if (this.props.courier.ShiftState === "closeAfterResolve") {
			return <span className="courierShiftState closeAfterResolve">
				<ClockIcon />Смена закроется после выполнения заказов
			</span>;
		}

		return null;
	}
}
CourierShiftCell = observer(CourierShiftCell);

class CourierShift extends Component {
	/** Закрыть окно смены курьера */
	onCancel = () => {
		if (this.props.store.CourierShift.ButtonLoading) return;
		this.props.store.CourierShift = undefined;
	}

	/** API запрос «ToggleCourierShift» на открытие/закрытие курьерской смены */
	onConfirm = () => {
		if (this.props.store.CourierShift.ButtonLoading) return;

		this.props.store.CourierShift.ButtonLoading = true;
		this.props.store.CourierShift.ErrorCode = "";

		CourierApi.toggleShift(this.props.store.CourierShift.getData(), (data) => {
			this.props.store.CourierShift.ButtonLoading = false;
			if (data.Success) {
				this.props.getData();
				this.props.store.CourierShift = undefined;
			} else this.props.store.CourierShift.ErrorCode = data.ErrorCode;
		});
	}

	render() {
		var params = this.props.store.CourierShift,
			text = <span>Вы действительно хотите {params.Active ? "открыть" : "закрыть"} смену 
					&nbsp;курьера <b key="b1">«{params.CourierName}»</b> в филиале&nbsp;
					<b key="b2">«{params.FilialName}»</b>?</span>;

		return(
			<FormModal
				ClassName="courierShift"
				Title={text}
				Loading={params.ButtonLoading}
				CancelTitle="Отменить"
				onSubmit={this.onConfirm}
				onClose={this.onCancel}
			>
				{!params.Active &&
					<CheckFilter
						Id="CloseAfterResolve"
						Title="Закрыть смену после выполнения всех заказов"
						Value={params.CloseAfterResolve}
						RowClass="nomargin"
						onChange={(value, id) => params.collect(id, value)}
					/>
				}
				{!params.CloseAfterResolve &&
					<DateInput
						Id="Date"
						Title={"Дата и время " + (params.Active ? "открытия" : "закрытия") + " смены"}
						Value={params.Date}
						WithTime={true}
						onChange={(value, id) => params.collect(id, value)}
					/>
				}
				<InlineError ErrorCode={params.ErrorCode} />
			</FormModal>
		)
	}
}
CourierShift = observer(CourierShift);

class UserItem extends Component {
	/** API запрос «UserSave» на сохранение данных пользователя */
	handleSubmit (event) {
		event.preventDefault();

		if (!this.props.store.User.validate()) return false;

		this.props.store.User.ButtonLoading = true;
		var isNew = this.props.store.User.Id === -1;

		UserApi.save(this.props.store.User.getData(), (data) => {
			this.props.store.User.ErrorCode = data.Success ? isNew ? "SUCCESS_NEW_USER_SAVE" : "SUCCESS_SAVE" : data.ErrorCode;
			this.props.store.User.SuccessSave = data.Success;
			this.props.store.User.ButtonLoading = false;

			if (data.Success && isNew) this.props.store.User.Id = data.Id;
		});
	}

	/** Закрытие окна редактирования */
	handleClose (event) {
		event.preventDefault();
		this.props.setId(undefined);
	}

	render() {
		var isCourier = this.props.store.CourierInterface;
		
		return (
			<section className="item" id="UserItem">
				<form onSubmit={this.handleSubmit.bind(this)}>
					<ItemNewHeader
						Title={buttonTitles[(this.props.store.User.Id === -1 ? "New" : "Edit") + this.props.Type]}
						ErrorCode={this.props.store.User.ErrorCode}
						ButtonLoading={this.props.store.User.ButtonLoading}
						CanManage={this.props.store.CanManage}
						SuccessSave={this.props.store.User.SuccessSave}
						handleClose={this.handleClose.bind(this)}
					/>
					<div className={"userGrid " + (isCourier ? "courier" : "user")
						+ (this.props.store.Merchants.length > 1 ? "" : " singleMerchant")
						+ (authUserState.HasERP ? "" : " withoutInn")}>
						<MainInfo store={this.props.store} />
						<MerchantsInfo store={this.props.store} />
						{!isCourier && <RolesInfo store={this.props.store} />}
						{authUserState.HasERP && <INNInfo store={this.props.store} />}
						{!isCourier && <IPInfo store={this.props.store} />}
						<FilialsInfo store={this.props.store} />
						{!isCourier && !_.isEmpty(this.props.store.User.Notifications.List) &&
							<NotificationBlock Notifications={this.props.store.User.Notifications} />
						}
						{!isCourier && <DashboardBlock Dashboards={this.props.store.User.Dashboards} />}
						{!isCourier && <RightsBlock Rights={this.props.store.User.Rights} />}
					</div>
				</form>
			</section>
		)
	}
}
UserItem = observer(UserItem);

class MainInfo extends Component {
	/** API метод «GenerateUserPassword» для сброса пароля пользователю */
	handleResetPassword (event) {
		event.preventDefault();

		if (this.props.store.User.Email === "") {
			errorState.setError("EMPTY_RESET_EMAIL");
			confirmState.closeConfirm();
			return false;
		}

		var text = <span>Вы действительно хотите сбросить пароль пользователю 
				&nbsp;<b key="b1">«{this.props.store.User ? this.props.store.User.FirstName : ""}»</b>? В результате пользователю на почту будет отправлено письмо с новыми аторизационными данными</span>;

		confirmState.openConfirm(text, () => {
			PasswordApi.reset(this.props.store.User.Id, (data) => {
				this.props.store.User.ErrorCode = data.Success ? "SUCCESS_RESET" : data.ErrorCode;
				this.props.store.User.SuccessSave = data.Success;
			});
		});
	}
	render () {
		var isRecipient = this.props.store.User.TipsRecipient && this.props.store.User.TipsState > -1;

		return(
			<div className="mainInfo section">
				<div className="authRow">
					<TextInput
						Id="Login"
						Title="Логин"
						Value={this.props.store.User.Login}
						Required={true}
						Disabled={this.props.store.User.Id > 0}
						Mask="7 (999) 999-99-99"
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
					<TextInput
						Id="Email"
						Title="E-mail"
						Value={this.props.store.User.Email}
						Required={true}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
					{this.props.store.User.Id !== -1 &&
						<button type="button" onClick={this.handleResetPassword.bind(this)}
							className='button secondary resetPassword'>Сброс пароля</button>
					}
				</div>
				<div className="nameRow">
					<TextInput
						Id="FirstName"
						Title="Имя"
						Value={this.props.store.User.FirstName}
						Required={true}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
					<TextInput
						Id="LastName"
						Title="Фамилия"
						Value={this.props.store.User.LastName}
						Required={this.props.store.User.TipsRecipient}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
					{this.props.store.User.TipsRecipient &&
						<TextInput
							Id="Patronymic"
							Title="Отчество"
							Value={this.props.store.User.Patronymic}
							Required={true}
							onChange={(value,id) => this.props.store.User.collect(id, value)}
						/>
					}
				</div>
				{authUserState.HasTips && this.props.store.CanRecipient &&
					<div className='tips'>
						<CheckFilter
							Id="TipsRecipient"
							Title="Является получателем чаевых"
							RowClass="nomargin"
							Disabled={isRecipient}
							Value={this.props.store.User.TipsRecipient}
							onChange={(value,id) => this.props.store.User.collect(id, value)}
						/>
						{isRecipient &&
							<p className="comment">{TipsStateTitles[this.props.store.User.TipsState]}</p>
						}
					</div>
				}
			</div>
		)
	}
}
MainInfo = observer(MainInfo);

class IPInfo extends Component {
	render () {
		return(
			<div className="ipInfo section">
				<div className="accessField">
					<AccessKeyIcon />
					<TextInput
						Id="IPList"
						Title="IP адрес (для ограничения доступа к сервису по IP)"
						Value={this.props.store.User.IPList}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
				</div>
			</div>
		)
	}
}
IPInfo = observer(IPInfo);

class INNInfo extends Component {
	render () {
		var isCourier = this.props.store.CourierInterface;

		return(
			<div className="innInfo section">
				<div className="accessField">
					<CashRegisterIcon />
					<TextInput
						Id="INN"
						Title="ИНН кассира (должны быть для работы с кассами)"
						Mask="999999999999"
						Value={this.props.store.User.INN}
						Disabled={isCourier && !this.props.store.CanManageINN}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
				</div>
				{isCourier && this.props.store.CanManageINN &&
					<CheckFilter
						Id="ShowINNFiscal"
						Title="Отображать в кассе"
						Disabled={!this.props.store.User.canShowInn}
						Value={this.props.store.User.ShowINNFiscal}
						onChange={(value,id) => this.props.store.User.collect(id, value)}
					/>
				}
			</div>
		)
	}
}
INNInfo = observer(INNInfo);

class MerchantsInfo extends Component {
	render () {
		return this.props.store.Merchants.length > 1 ? (
			<div className="merchants section">
				{!this.props.store.CourierInterface &&
					<p className="comment">Настройка пользователя выполняется в рамках текущего предприятия.</p>
				}
				<CheckBoxGroup
					Id="MerchantIds"
					Title="Предприятия"
					List={this.props.store.Merchants}
					Value={this.props.store.User.MerchantIds}
					ParseType="number"
					onChange={(value,id) => this.props.store.User.collect(id, value)}
				/>
			</div>
		) : null;
	}
}
MerchantsInfo = observer(MerchantsInfo);

class RolesInfo extends Component {
	render () {
		return(
			<div className="roles section">
				<p className='comment'>При назначении должности все ее настройки автоматически применяются к пользователю. Вы можете дать пользователю индивидуальные права доступа в блоке ниже.</p>
				<CheckBoxGroup
					Id="Roles"
					Title="Должности"
					List={this.props.store.User.Roles}
					Value={this.props.store.User.RoleIds}
					ParseType="number"
					onChange={(value,id) => this.props.store.User.collect(id, value)}
				/>
			</div>
		)
	}
}
RolesInfo = observer(RolesInfo);

class FilialsInfo extends Component {
	render () {
		return(
			<div className="filials">
				{/* TODO: заменить выбор филиалов на CheckBoxGroup после добавления поддержки вложенных списков
					(города → филиалы → точки продаж и кассы). */}
				{_.map(this.props.store.User.Filials.Cities, (city) => {
					return(<FilialsCities
						key={city.Id}
						CityId={city.Id}
						Title={city.Title}
						Filials={city.Filials}
						store={this.props.store}
					/>)
				})}
			</div>
		)
	}
}
FilialsInfo = observer(FilialsInfo);

class FilialsCities extends Component {
	render() {
		return(
			<div className="city section">
				{!this.props.store.CourierInterface &&
					<>
						<div className="sectionTitle">
							<LocationAccessIcon />
							<h4>Доступ к филиалам: {this.props.Title}</h4>
							<CheckGroup
								Type="checkbox"
								Id="CheckAll"
								RowClass="nomargin"
								List={[{ Id : "true", Title : "Выбрать все" }]}
								Value={this.props.store.User.Filials.CheckAll[this.props.CityId] ? ["true"] : []}
								onChange={(value, id) => {
									this.props.store.User.Filials.collectCity(this.props.CityId, value);
								}}
							/>
						</div>
						<div className="filialList">
							{this.props.Filials.map((filial) => <UserFilialInfo
								key={filial.Id}
								Filial={filial}
								store={this.props.store}
							/>)}
						</div>
					</>
				}
				{this.props.store.CourierInterface &&
					<CheckGroup
						Id="Filials"
						Type="checkbox"
						Title={"Филиалы " + this.props.Title}
						List={this.props.Filials}
						Value={this.props.store.User.Filials.Filials}
						onChange={(value, id) => this.props.store.User.Filials.collect(id, value)}
					/>
				}
			</div>
		)
	}
}
FilialsCities = observer(FilialsCities);

class UserFilialInfo extends Component {
	render() {
		var filial = this.props.Filial,
			filials = this.props.store.User.Filials;

		return(
			<div className="filial">
				<GroupCheckbox
					Id={"Filials_" + filial.Id}
					Title={filial.Title}
					Value={filials.getPOSCheckedState(filial.Id)}
					onChange={(value, id) => filials.collect(id, value)}
				/>
				{!_.isEmpty(filial.POS) && authUserState.HasERP && <h5>Точки продаж</h5>}
				{!_.isEmpty(filial.POS) && authUserState.HasERP && _.map(filial.POS, (pos) => {
					return(<div className="pos" key={pos.Id}>
						<CheckGroup
							Id="POS"
							Type="checkbox"
							List={[pos]}
							Value={filials.POS}
							RowClass="nomargin"
							Disabled={_.indexOf(filials.Filials, filial.Id) === -1}
							onChange={(value, id) => filials.collect(id, value)}
						/>
						{pos.HasCassa &&
							<CheckGroup
								Id="Cassa"
								Type="checkbox"
								List={[{ Id : pos.Id, Title : "Касса" }]}
								Value={filials.Cassa}
								RowClass="cassa nomargin"
								Disabled={_.indexOf(filials.POS, pos.Id) === -1}
								onChange={(value, id) => filials.collect(id, value)}
							/>
						}
					</div>)
				})}
			</div>
		)
	}
}
UserFilialInfo = observer(UserFilialInfo);
